
export default {
    props: {
        level: {
            type: Number,
            default: 3,
        },
        bColor: {
            type: String,
            default: '#F4EAE0',
        },
        tColor: {
            type: String,
            default: '#1a1a1a',
        },
        borderColor: {
            type: String,
            default: '#cccccc',
        },
        marginTop: {
            type: Number,
            default: 0,
        },
    },

    data() {
        return {
            mBottom: 0,
        }
    },

    mounted() {
        if (this.$refs?.separatorHeading?.$el) this.mBottom = -this.$refs.separatorHeading.$el.clientHeight / 2 - 5
    },
}
